<template>
  <el-button
    :class="classValue"
    :style="clsStyle"
    :type="type"
    :icon="activeIcon"
    :size="size"
    :disabled="(isViewOnly() && !allowViewOnly) || loading || disabled"
    :text="btnStyle === 'text' ? true : false"
    :plain="btnStyle === 'plain' ? true : false"
    :round="round"
    :circle="circle"
    @click="onClick">
      &nbsp;<slot v-if="this.$slots && !this.isEmptyObject(this.$slots)"></slot>
      <span v-else>
        &nbsp;{{text}}
      </span>
  </el-button>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'

export default {
  name: 'download-button',

  mixins: [PostMixins],

  props: {
    url: {
      type: String,
      required: true
    },

    text: {
      type: String,
      default: 'Download'
    },

    cls: {
      type: String,
      default: null
    },

    clsStyle: {
      type: String,
      default: null
    },

    textColor: {
      type: String,
      default: null
    },

    backgroundColor: {
      type: String,
      default: null
    },

    icon: {
      type: String,
      default: 'fa fa-download'
    },

    spiningIcon: {
      type: String,
      default: 'fa fa-spinner fa-spin'
    },

    btnStyle: {
      type: String,
      validator: function (value) {
        return value !== null ? ['text', 'plain', 'primary', 'success', 'info', 'warning'].indexOf(value) !== -1 : true
      },
      default: 'info'
    },
    round: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },

    type: {
      type: String,
      validator: function (value) {
        return value !== null ? ['info', 'primary', 'success', 'warning', 'danger'].indexOf(value) !== -1 : true
      },
      default: null
    },

    timer: {
      type: Number,
      default: 3,
      validator: function (value) {
        if (value >= 1 && value <= 7) {
          return true
        } else {
          return false
        }
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },

    // XOL-650: a View Only user may still download (the e-mail landing). A download is a read,
    // not an edit, and the GET is not behind viewonly.gate. Default false: every other consumer
    // stays disabled for View Only.
    allowViewOnly: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onClick () {
      if (this.loading) return

      // Open the URL directly in a new tab inside the user-gesture window so
      // popup blockers don't fire. The browser handles its own loading state
      // in the new tab; the spinner here is just click-acknowledgement on the
      // originating button.
      window.open(this.getEndpoint(this.url), '_blank', 'noopener')

      this.loading = true
      this.activeIcon = this.spiningIcon

      setTimeout(() => {
        this.loading = false
        this.activeIcon = this.icon
      }, this.timer * 1000)
    }
  },

  data () {
    return {
      activeIcon: this.icon,
      loading: false,
      classValue: (this.cls ? this.cls + ' ' : '') + (this.textColor ? 'color:' + this.textColor + '; ' : '') + (this.backgroundColor ? 'background-color: ' + this.backgroundColor + ';' : '')
    }
  }
}


</script>
